module.exports = __webpack_public_path__ + "static/media/list-numbered.7a734bbe.svg";